export const AuthLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100vw", height: "100vh", alignItems: "center" }}>
      {children}
    </div>
  )
}
